module.exports = __webpack_public_path__ + "img/Sony_resivedA9F.ecbc5c91.png";